<template lang="pug">
div.row
    top-purchased-by-tags
    top-purchased-products
    top-grossing-products
</template>
<script>
import topPurchasedByTags from './top-purchased-by-tags.vue';
import topPurchasedProducts from './top-purchased-products.vue';
import topGrossingProducts from './top-grossing-products.vue';
import { mapActions, mapGetters } from 'vuex';
import { Event } from '../../event-bus';

export default {
    components: {
        topPurchasedByTags,
        topPurchasedProducts,
        topGrossingProducts,
    },

    computed: {
        ...mapGetters(['activeOutlet', 'startDate', 'endDate']),

        dateFilter() {
            return {
                since: this.startDate,
                until: this.endDate,
            };
        },
    },

    watch: {
        activeOutlet(newVal, oldVal) {
            this.$emit('fetch-data', newVal);
        },

        dateFilter(newVal) {
            this.$emit('fetch-data', newVal);
        },
    },

    mounted() {
        this.getChartData();

        this.$nextTick(() => {
            this.$on('fetch-data', () => {
                this.getChartData();
            });

            window.onresize = () => {
                Event.$emit('window-resized');
            };
        });
    },

    methods: {
        ...mapActions('reportProduct', ['getChartData']),
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/item/boxChart.vue